import { $http } from "@/plugins/api";
import { useFlag } from "@/composables/useFlags/useFlag";

const { isFeatureAvailable: isIncidentsV3Available } = useFlag("INCIDENTS_V3");

const state = {
  resolutionHistory: [],
};

const getters = {
  resolutionHistory: (state) => state.resolutionHistory,
};

const actions = {
  async getResolutionHistory({ commit }, { globalOrganisationID, params }) {
    const filterParams = new URLSearchParams(params);

    if (isIncidentsV3Available.value) {
      const res = await $http.get(
        `${
          import.meta.env.VITE_API_CLIENT_V3
        }/history/globalOrganisationID/${globalOrganisationID}/stats/incidents?${filterParams.toString()}`,
      );

      commit("setResolutionHistory", res.data.data);
    } else {
      const res = await $http.get(
        `${
          import.meta.env.VITE_API_CLIENT
        }/v1/pt/history/globalOrganisationID/${globalOrganisationID}/stats/incidents?${filterParams.toString()}`,
      );

      commit("setResolutionHistory", res.data.data);
    }
  },
};

const mutations = {
  setResolutionHistory: (state, data) => (state.resolutionHistory = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
